import Vue from "vue";
import store from "@/store";
import { STATIC_HOST } from '@/api/constants'

const preUrl = STATIC_HOST
let loading = false;
let pString = "";
let allString = "";

let buffer = ''

let controller = null;
let signal = null;
let is_greet = 0; // 第一次为1 其他时候不为1 agent版本针对老的对话接口

export const clearController = () => {
  controller = null;
  signal = null;
  buffer = ''
};
function addHistoryText(text){
  let chatHistory = store?.state?.chatHistory
  if (chatHistory.length > 0) {

    let lastElement = chatHistory.pop()

    if (lastElement.length === 2){
      const answerText = lastElement[1]
      if (answerText === ''){
        lastElement[1] = text
        chatHistory.push(lastElement)
        store.commit('updateHistory', chatHistory)
      }
    }
  }
}
export const setNewAbortController = async () => {
  clearController();
  // 加这玩意停不了
  // await setTimeout(() => {
  controller = new AbortController();
  signal = controller.signal;
  // }, 0);
};
export const controllerAbort = (a) => {
  if (controller) {
    if (signal?.aborted === false) {
      controller?.abort?.();
    }
  }
  buffer = ''
  clearController();
};
export const clearAllStr =  () => {
  allString = ''
  buffer = ''
  // pString = ''
}

export const askApiStream = async (text, textModel, name) => {
  console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  if (!text) {
    return Promise.reject({ msg: "缺少必备参数" });
  }
  const isHello = name.includes('resultPrompt')
  // 首次1 // 正常聊天 2 其他 3
  if (name === 'sendMsgClick' || name === '语音识别结果' || isHello){
    if (is_greet === 0){
      is_greet = is_greet + 1
    } else {
      is_greet = 2
    }
  } else {
    is_greet = 3
  }
  const id = String(store?.state?.vuex_app_project_data?.id);
  if (id === "undefined") {
    console.log('*****缺少项目ID')
    return Promise.reject({ msg: "缺少项目ID" });
  }
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askApiStream.js:45 ~ askApiStream ~ error : `,
        error
      );
    }

    loading = true;
    let new_year_greet = 0
    if (text === '新年拜年'){
      new_year_greet = 1
    }
    let chatHistory = store?.state?.chatHistory
    // console.log('store?.state?.chatHistory', chatHistory)
    const newArray = chatHistory.slice(0, chatHistory.length - 1)
    const chatType = store?.state?.weiXinMark && store?.state?.appletInfo?.user_token !== ''
    let introduce_type = 0
    if(isHello){
      if(name === 'resultPrompt_A'){
        introduce_type = 1
      } else if(name === 'resultPrompt_B'){
        introduce_type = 2
      } else {
        introduce_type = 3
      }
    }
    const response = await fetch(preUrl + "chat-stream",
      {
        signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: "Bearer " + store?.state?.vuex_app_token || "",
          'USER-TOKEN': store?.state?.appletInfo?.user_token || '',
        },
        body: JSON.stringify({
          history: newArray,
          project_id: id,
          project_name: store?.state?.vuex_app_project_data?.name,
          question: isHello ? '' : text, // 主动打招呼则传空
          new_year_greet: new_year_greet,
          visitor_id: store?.state?.visitUserName,
          is_greet: is_greet,
          chat_type: chatType ? 'applet' : 'h5',
          wx_phone: store.state.wxPhone,
          introduce_type: introduce_type
        }),
      }).then().catch(error => {
      // 捕获异常，但不显示错误信息
      console.error('chat-stream Fetch error :', error);
      if (error.name !== 'AbortError') {
        console.error('Fetch error:', error);
      }
      // 如果错误不是因为用户终止请求，则处理错误
    });
    //
    /* noah modify 20240409
    if (!response) {
      return Promise.reject({ msg: "无res" });
    } */
    const reader = response.body.getReader();
    console.error(
      `🚀 ~ file: askApiStream.js:73 ~ askApiStream ~ response : `, response?.status,
      response
    );
    if (response?.status !== 200) {
      let _decoder = new TextDecoder();
      let _resultData = '';
      let _result = true;
      while (_result) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("500 error Stream ended");
          _result = false;
          break;
        }
        _resultData += _decoder.decode(value);
      }
      try {
        const errorBody  = JSON.parse(_resultData)
        console.log('errorBody.', errorBody)
        //console.log('errorBody.msg',errorBody.msg)
        if (response?.status === 500){
          return Promise.reject({
            msg: errorBody?.msg ? errorBody?.msg : "回复的接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        } else {
          return Promise.reject({
            msg: response?.status ? "接口错误 " + response?.status : "回复接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
      } catch (error){
        console.log('JSON.stringify(resultData) error:', error)
      }

    }
    const readStream = async () => {
      loading = false;

      while (true) {
        const { done, value } = await reader.read();

        const decoder = new TextDecoder();
        const decodedString = decoder.decode(value);
        // let str = decodedString.replace(/\r?\n/g, '$^$')
        buffer += decodedString;
        const sentenceEndRegex = /([！?；。!;?])/g; // 匹配分句符号
        const sentences = [];
        let lastIndex = 0;
        let match;

        while ((match = sentenceEndRegex.exec(buffer)) !== null) {
          const endPos = match.index + 1; // 包含符号的位置
          sentences.push(buffer.substring(lastIndex, endPos));
          lastIndex = endPos;
        }
        // 更新缓存：保留未处理完的字符
        buffer = buffer.substring(lastIndex)

        // 推送完整句子到UI
        if (sentences.length > 0) {
          for (let i = 0; i < sentences.length; i++) {
            const sentence = sentences[i]
            // console.log('将要发出的句子：', sentence)
            const resultJson = extractJson(sentence) // sentence `我给你推荐一款唐老鸭手办`{"intention": 1}
            // console.log('extractJson resultJson', resultJson)

            let currStr = resultJson.originStr.replace(/\#/g,'').replace(/\s/g, '')
            // console.log('will send onChatStream currStr', currStr)
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              currStr,
              "数据流下载完毕 done",
              textModel
            )
          }

        }
        if (decodedString === "[DONE]" || done) {
          console.log('**************done')
          return Promise.resolve()
        }
      }
    };
    await readStream.call(this); // 使用call方法确保箭头函数中的this引用正确的Vue组件实例
    clearController();
  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      /* if(error === 'TypeError: Failed to fetch'){
        console.log('TypeError: Failed to fetch')
      } */
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败", noShowToast: true  });
      }

    }
  }
}

export const askApiStream_copy_json = async (text, textModel, name) => {
  console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  if (!text) {
    return Promise.reject({ msg: "缺少必备参数" });
  }
  const isHello = name.includes('resultPrompt')
  // 首次1 // 正常聊天 2 其他 3
  if (name === 'sendMsgClick' || name === '语音识别结果' || isHello){
    if (is_greet === 0){
      is_greet = is_greet + 1
    } else {
      is_greet = 2
    }
  } else {
    is_greet = 3
  }
  const id = String(store?.state?.vuex_app_project_data?.id);
  if (id === "undefined") {
    console.log('*****缺少项目ID')
    return Promise.reject({ msg: "缺少项目ID" });
  }
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askApiStream.js:45 ~ askApiStream ~ error : `,
        error
      );
    }

    loading = true;
    let new_year_greet = 0
    if (text === '新年拜年'){
      new_year_greet = 1
    }
    let chatHistory = store?.state?.chatHistory
    // console.log('store?.state?.chatHistory', chatHistory)
    const newArray = chatHistory.slice(0, chatHistory.length - 1)
    const chatType = store?.state?.weiXinMark && store?.state?.appletInfo?.user_token !== ''
    let introduce_type = 0
    if(isHello){
      if(name === 'resultPrompt_A'){
        introduce_type = 1
      } else if(name === 'resultPrompt_B'){
        introduce_type = 2
      } else {
        introduce_type = 3
      }
    }
    const response = await fetch(preUrl + "chat-stream",
      {
        signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: "Bearer " + store?.state?.vuex_app_token || "",
          'USER-TOKEN': store?.state?.appletInfo?.user_token || '',
        },
        body: JSON.stringify({
          history: newArray,
          project_id: id,
          project_name: store?.state?.vuex_app_project_data?.name,
          question: isHello ? '' : text, // 主动打招呼则传空
          new_year_greet: new_year_greet,
          visitor_id: store?.state?.visitUserName,
          is_greet: is_greet,
          chat_type: chatType ? 'applet' : 'h5',
          wx_phone: store.state.wxPhone,
          introduce_type: introduce_type
        }),
      }).then().catch(error => {
      // 捕获异常，但不显示错误信息
      console.error('chat-stream Fetch error :', error);
      if (error.name !== 'AbortError') {
        console.error('Fetch error:', error);
      }
      // 如果错误不是因为用户终止请求，则处理错误
    });
    //
    /* noah modify 20240409
    if (!response) {
      return Promise.reject({ msg: "无res" });
    } */
    const reader = response.body.getReader();
    console.error(
      `🚀 ~ file: askApiStream.js:73 ~ askApiStream ~ response : `, response?.status,
      response
    );
    if (response?.status !== 200) {
      let _decoder = new TextDecoder();
      let _resultData = '';
      let _result = true;
      while (_result) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("500 error Stream ended");
          _result = false;
          break;
        }
        _resultData += _decoder.decode(value);
      }
      try {
        const errorBody  = JSON.parse(_resultData)
        console.log('errorBody.', errorBody)
        //console.log('errorBody.msg',errorBody.msg)
        if (response?.status === 500){
          return Promise.reject({
            msg: errorBody?.msg ? errorBody?.msg : "回复的接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        } else {
          return Promise.reject({
            msg: response?.status ? "接口错误 " + response?.status : "回复接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
      } catch (error){
        console.log('JSON.stringify(resultData) error:', error)
      }

    }
    const readStream = async () => {
      loading = false;

      while (true) {
        const { done, value } = await reader.read();

        const decoder = new TextDecoder();
        const decodedString = decoder.decode(value);
        // let str = decodedString.replace(/\r?\n/g, '$^$')
        const str = decodedString;
        // str = str.replace(/\r/, "$^R^$");
        // str = str.replace(/\n/, "$^N^$");
        // const stepStrList = ["。", "；", "！"];
        let step = false;

        // if (/\n/.test(str)) {
        //   step = true;
        // }
        // stepStrList.forEach((element) => {
        //   const pattern = new RegExp(`/${element}/`);
        //   if (pattern.test(str)) {
        //     step = element;
        //   }
        // });
        if (/。/.test(str)) {
          step = "。";
        } else if (/；/.test(str)) {
          step = "；";
        } else if (/！/.test(str)) {
          step = "！";
        }
          // else if (/./.test(str)) {
          //   step = ".";
        // }
        else if (/;/.test(str)) {
          step = ";";
        } else if (/!/.test(str)) {
          step = "!";
        } else if (/\?/.test(str)) {
          step = "?";
        } else if (/？/.test(str)) {
          step = "？";
        }
        // .replace(/^data: \s*/g, "") // 使用全局替换（添加"g"标志）
        // .replace(/\n/g, "");
        if (done) {
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          // const str = pString.split(step)[0]; // old
          let str = pString.split(step)[0];
          str.replace(/\n/g, '')
          str.replace(/\#/g,'')

          //let str = pString.split("\n")[0];

          /* let str = pString.replace(/\n/g, "")
          str = str.split(step)[0]; */ // noah modify 删除换行 取分割符前面的

          if (str) {
            console.error("!!!!!!!!!!!!! 1 _sendMsgAnswerShowAndPlayEvent:" + str);
            const intentJson = extractJson(str)
            // console.log('intentJson:', intentJson)
            str = intentJson.originStr
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str,
              "数据流下载完毕 done",
              textModel
            );
            pString = "";
          }
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }
          console.log("数据流1下载完毕 done\n\n", text, allString);
          return Promise.resolve();
        }
        if (str === "[DONE]") {
          console.log("*** enter str === [DONE] \n\n", allString);
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          const str = pString.split(step)[0];
          if (str) {
            console.error(
              "🚀 ~ file: askApiStream.js:48 ~ readStream ~ str 结尾: ",
              str
            );
            console.error("!!!!!!!!!!!!! 2 _sendMsgAnswerShowAndPlayEvent");
            const intentJson = extractJson(str)
            // console.log('intentJson:', intentJson)
            const str2 = intentJson.originStr
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str2,
              "数据流2下载完毕 str === DONE",
              textModel
            );
            if (name === 'sendMsgClick' || name === '语音识别结果'){
              addHistoryText(allString)
            }
            pString = "";
          }
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }
          console.log("数据流2下载完毕 str === DONE\n\n", allString);
          return Promise.resolve();
        }
        // str = str.split("data: ");
        // let newStreamDataSSE = str && str[str.length - 1];

        const newStreamDataSSE = str;

        // 分割话说话进行提交合成
        if (newStreamDataSSE !== "[DONE]") {
          allString += newStreamDataSSE;
          // .replace(/\n/, "$^N^$")
          // .replace(/\r/, "$^R^$");
          if (step) {
            // const strList = newStreamDataSSE.split("\n");
            const strList = newStreamDataSSE.split(step);
            // 拿第一个,补上符号
            pString += strList[0] + step;
            if (pString) {
              console.error("!!!!!!!!!!!!! 3 _sendMsgAnswerShowAndPlayEvent");
              // 反馈给tts
              console.log('反馈给tts pString:' + pString)
              const intentJson = extractJson(pString)
              // console.log('intentJson:', intentJson)
              const str2 = intentJson.originStr
              Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
                str2,
                "pString",
                textModel
              );
            }
            // 有可能不止一个，有好几个个\n合在一起，所以取剩下的,length-1可能就是0
            const strListLength = strList.length
            if (strList && strListLength > 1) {
              const newList = strList.slice(1, strList.length);
              pString = newList.join(step) || "";
            } else {
              pString = "";
            }
          } else {
            pString += newStreamDataSSE;
          }
        }
      }
    };
    await readStream.call(this); // 使用call方法确保箭头函数中的this引用正确的Vue组件实例
    clearController();
  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      /* if(error === 'TypeError: Failed to fetch'){
        console.log('TypeError: Failed to fetch')
      } */
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败", noShowToast: true  });
      }

    }
  }
}

export const askApiStream_copy = async (text, textModel, name) => {
  console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  if (!text) {
    return Promise.reject({ msg: "缺少必备参数" });
  }
  const isHello = name.includes('resultPrompt')
  // 首次1 // 正常聊天 2 其他 3
  if (name === 'sendMsgClick' || name === '语音识别结果' || isHello){
    if (is_greet === 0){
      is_greet = is_greet + 1
    } else {
      is_greet = 2
    }
  } else {
    is_greet = 3
  }
  const id = String(store?.state?.vuex_app_project_data?.id);
  if (id === "undefined") {
    console.log('*****缺少项目ID')
    return Promise.reject({ msg: "缺少项目ID" });
  }
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askApiStream.js:45 ~ askApiStream ~ error : `,
        error
      );
    }

    loading = true;
    let new_year_greet = 0
    if (text === '新年拜年'){
      new_year_greet = 1
    }
    let chatHistory = store?.state?.chatHistory
    // console.log('store?.state?.chatHistory', chatHistory)
    const newArray = chatHistory.slice(0, chatHistory.length - 1)
    const chatType = store?.state?.weiXinMark && store?.state?.appletInfo?.user_token !== ''
    let introduce_type = 0
    if(isHello){
      if(name === 'resultPrompt_A'){
        introduce_type = 1
      } else if(name === 'resultPrompt_B'){
        introduce_type = 2
      } else {
        introduce_type = 3
      }
    }
    const response = await fetch(preUrl + "chat-stream",
      {
        signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: "Bearer " + store?.state?.vuex_app_token || "",
          'USER-TOKEN': store?.state?.appletInfo?.user_token || '',
        },
        body: JSON.stringify({
          history: newArray,
          project_id: id,
          project_name: store?.state?.vuex_app_project_data?.name,
          question: isHello ? '' : text, // 主动打招呼则传空
          new_year_greet: new_year_greet,
          visitor_id: store?.state?.visitUserName,
          is_greet: is_greet,
          chat_type: chatType ? 'applet' : 'h5',
          wx_phone: store.state.wxPhone,
          introduce_type: introduce_type
        }),
      }).then().catch(error => {
      // 捕获异常，但不显示错误信息
      console.error('chat-stream Fetch error :', error);
      if (error.name !== 'AbortError') {
        console.error('Fetch error:', error);
      }
      // 如果错误不是因为用户终止请求，则处理错误
    });
    //
    /* noah modify 20240409
    if (!response) {
      return Promise.reject({ msg: "无res" });
    } */
    const reader = response.body.getReader();
    console.error(
      `🚀 ~ file: askApiStream.js:73 ~ askApiStream ~ response : `, response?.status,
      response
    );
    if (response?.status !== 200) {
      let _decoder = new TextDecoder();
      let _resultData = '';
      let _result = true;
      while (_result) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("500 error Stream ended");
          _result = false;
          break;
        }
        _resultData += _decoder.decode(value);
      }
      try {
        const errorBody  = JSON.parse(_resultData)
        console.log('errorBody.', errorBody)
        //console.log('errorBody.msg',errorBody.msg)
        if (response?.status === 500){
          return Promise.reject({
            msg: errorBody?.msg ? errorBody?.msg : "回复的接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        } else {
          return Promise.reject({
            msg: response?.status ? "接口错误 " + response?.status : "回复接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
      } catch (error){
        console.log('JSON.stringify(resultData) error:', error)
      }

    }
    const readStream = async () => {
      loading = false;

      while (true) {
        const { done, value } = await reader.read();

        const decoder = new TextDecoder();
        const decodedString = decoder.decode(value);
        // let str = decodedString.replace(/\r?\n/g, '$^$')
        const str = decodedString;
        // str = str.replace(/\r/, "$^R^$");
        // str = str.replace(/\n/, "$^N^$");
        // const stepStrList = ["。", "；", "！"];
        let step = false;

        // if (/\n/.test(str)) {
        //   step = true;
        // }
        // stepStrList.forEach((element) => {
        //   const pattern = new RegExp(`/${element}/`);
        //   if (pattern.test(str)) {
        //     step = element;
        //   }
        // });
        if (/。/.test(str)) {
          step = "。";
        } else if (/；/.test(str)) {
          step = "；";
        } else if (/！/.test(str)) {
          step = "！";
        }
          // else if (/./.test(str)) {
          //   step = ".";
        // }
        else if (/;/.test(str)) {
          step = ";";
        } else if (/!/.test(str)) {
          step = "!";
        } else if (/\?/.test(str)) {
          step = "?";
        } else if (/？/.test(str)) {
          step = "？";
        }
        // .replace(/^data: \s*/g, "") // 使用全局替换（添加"g"标志）
        // .replace(/\n/g, "");
        if (done) {
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          // const str = pString.split(step)[0]; // old
          let str = pString.split(step)[0];
          str.replace(/\n/g, '')
          str.replace(/\#/g,'')

          //let str = pString.split("\n")[0];

          /* let str = pString.replace(/\n/g, "")
          str = str.split(step)[0]; */ // noah modify 删除换行 取分割符前面的
          if (str) {
            console.error("!!!!!!!!!!!!! 1 _sendMsgAnswerShowAndPlayEvent:" + str);
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str,
              "数据流下载完毕 done",
              textModel
            );
            pString = "";
          }
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }
          console.log("数据流1下载完毕 done\n\n", text, allString);
          return Promise.resolve();
        }
        if (str === "[DONE]") {
          console.log("*** enter str === [DONE] \n\n", allString);
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          const str = pString.split(step)[0];
          if (str) {
            console.error(
              "🚀 ~ file: askApiStream.js:48 ~ readStream ~ str 结尾: ",
              str
            );
            console.error("!!!!!!!!!!!!! 2 _sendMsgAnswerShowAndPlayEvent");
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str,
              "数据流2下载完毕 str === DONE",
              textModel
            );
            if (name === 'sendMsgClick' || name === '语音识别结果'){
              addHistoryText(allString)
            }
            pString = "";
          }
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }
          console.log("数据流2下载完毕 str === DONE\n\n", allString);
          return Promise.resolve();
        }
        // str = str.split("data: ");
        // let newStreamDataSSE = str && str[str.length - 1];

        const newStreamDataSSE = str;

        // 分割话说话进行提交合成
        if (newStreamDataSSE !== "[DONE]") {
          allString += newStreamDataSSE;
          // .replace(/\n/, "$^N^$")
          // .replace(/\r/, "$^R^$");
          if (step) {
            // const strList = newStreamDataSSE.split("\n");
            const strList = newStreamDataSSE.split(step);
            // 拿第一个,补上符号
            pString += strList[0] + step;
            if (pString) {
              console.error("!!!!!!!!!!!!! 3 _sendMsgAnswerShowAndPlayEvent");
              // 反馈给tts
              console.log('反馈给tts pString:' + pString)
              Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
                pString,
                "pString",
                textModel
              );
            }
            // 有可能不止一个，有好几个个\n合在一起，所以取剩下的,length-1可能就是0
            const strListLength = strList.length
            if (strList && strListLength > 1) {
              const newList = strList.slice(1, strList.length);
              pString = newList.join(step) || "";
            } else {
              pString = "";
            }
          } else {
            pString += newStreamDataSSE;
          }
        }
      }
    };
    await readStream.call(this); // 使用call方法确保箭头函数中的this引用正确的Vue组件实例
    clearController();
  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      /* if(error === 'TypeError: Failed to fetch'){
        console.log('TypeError: Failed to fetch')
      } */
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败", noShowToast: true  });
      }

    }
  }
}

// agent版本，加入history chat
export const askApiStreamAgent = async (text, textModel, name) => {
  // console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  if (!text) {
    return Promise.reject({ msg: "缺少必备参数" });
  }

  const id = String(store?.state?.vuex_app_project_data?.id);
  if (id === "undefined") {
    console.log('*****缺少项目ID')
    return Promise.reject({ msg: "缺少项目ID" });
  }
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askApiStream.js:45 ~ askApiStream ~ error : `,
        error
      );
    }

    loading = true;
    let new_year_greet = 0
    if (text === '新年拜年'){
      new_year_greet = 1
    }
    let chatHistory = store?.state?.chatHistory
    // console.log('store?.state?.chatHistory', chatHistory)
    const newArray = chatHistory.slice(0, chatHistory.length - 1)
    //console.log('store?.state?.chatHistory 222', chatHistory)
    /* if (lastElement.length === 2){
      if (lastElement[1] === ''){

      }
    } */

    console.log('store?.state?.chatHistory', newArray)
    const response = await fetch(preUrl + 'agent_chat', // 'chat-stream',
      {
        signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: "Bearer " + store?.state?.vuex_app_token || "",
          'USER-TOKEN': store?.state?.appletInfo?.user_token || '',
        },
        body: JSON.stringify({
          history: newArray,
          project_id: id,
          project_name: store?.state?.vuex_app_project_data?.name,
          question: text,
          new_year_greet: new_year_greet,
          chat_type: store?.state?.weiXinMark ? 'applet' : 'h5',
          visitor_id: store?.state?.visitUserName

        }),
    }).then().catch(error => {
      // 捕获异常，但不显示错误信息
      console.error('chat-stream Fetch error :', error);
      if (error.name !== 'AbortError') {
        console.error('Fetch error:', error);
      }
      // 如果错误不是因为用户终止请求，则处理错误
    });
    //
    /* noah modify 20240409
    if (!response) {
      return Promise.reject({ msg: "无res" });
    } */
    const reader = response.body.getReader();
    console.error(
      `🚀 ~ file: askApiStream.js:73 ~ askApiStream ~ response : `, response?.status,
      response
    );
    if (response?.status !== 200) {
      let _decoder = new TextDecoder();
      let _resultData = '';
      let _result = true;
      while (_result) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("500 error Stream ended");
          _result = false;
          break;
        }
        _resultData += _decoder.decode(value);
      }
      try {
        const errorBody  = JSON.parse(_resultData)
        console.log('errorBody.', errorBody)
        //console.log('errorBody.msg',errorBody.msg)
        if (response?.status === 500){
          return Promise.reject({
            msg: errorBody?.msg ? errorBody?.msg : "回复的接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
        else {
          return Promise.reject({
            msg: response?.status ? "接口错误 " + response?.status : "回复接口错误",//弹出系统的msg：当前账户余额不足，请充值后使用
          });
        }
      } catch (error){
        console.log('JSON.stringify(resultData) error:', error)
      }

    }
    const readStream = async () => {
      loading = false;

      while (true) {
        const { done, value } = await reader.read();

        const decoder = new TextDecoder();
        const decodedString = decoder.decode(value);
        // let str = decodedString.replace(/\r?\n/g, '$^$')
        const str = decodedString;
        // str = str.replace(/\r/, "$^R^$");
        // str = str.replace(/\n/, "$^N^$");
        // const stepStrList = ["。", "；", "！"];
        let step = false;

        // if (/\n/.test(str)) {
        //   step = true;
        // }
        // stepStrList.forEach((element) => {
        //   const pattern = new RegExp(`/${element}/`);
        //   if (pattern.test(str)) {
        //     step = element;
        //   }
        // });
        if (/。/.test(str)) {
          step = "。";
        } else if (/；/.test(str)) {
          step = "；";
        } else if (/！/.test(str)) {
          step = "！";
        }
        // else if (/./.test(str)) {
        //   step = ".";
        // }
        else if (/;/.test(str)) {
          step = ";";
        } else if (/!/.test(str)) {
          step = "!";
        } else if (/\?/.test(str)) {
          step = "?";
        } else if (/？/.test(str)) {
          step = "？";
        }
        // .replace(/^data: \s*/g, "") // 使用全局替换（添加"g"标志）
        // .replace(/\n/g, "");
        if (done) {
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];

          let str = pString.split(step)[0];
          str.replace(/\n/g, '')
          str.replace(/\#/g,'')

          // 拦截字符串 特殊字符串处理
          // answer = answer.replace(/\#/g,'')

          //let str = pString.split("\n")[0];

          /* let str = pString.replace(/\n/g, "")
          str = str.split(step)[0]; */ // noah modify 删除换行 取分割符前面的
          if (str) {
            console.error("!!!!!!!!!!!!! 1 _sendMsgAnswerShowAndPlayEvent:" + str);
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str,
              "数据流下载完毕 done",
              textModel
            );

            pString = "";
          }

          // 回答保存进历史记录
          // console.log('判断历史的name：', name)
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }

          console.log("数据流1下载完毕 done\n\n", text, allString);
          return Promise.resolve();
        }
        if (str === "[DONE]") {
          console.log("*** enter str === [DONE] \n\n", allString);
          // 可能结尾有 \n
          // const str = pString.split("\n")[0];
          const str = pString.split(step)[0];
          if (str) {
            console.error(
              "🚀 ~ file: askApiStream.js:48 ~ readStream ~ str 结尾: ",
              str
            );
            console.error("!!!!!!!!!!!!! 2 _sendMsgAnswerShowAndPlayEvent");
            Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
              str,
              "数据流2下载完毕 str === DONE",
              textModel
            );

            // 回答保存进历史记录
            // console.log('判断历史的name：', name)
            if (name === 'sendMsgClick' || name === '语音识别结果'){
              addHistoryText(allString)
            }
            pString = "";
          }

          // 回答保存进历史记录
          // console.log('判断历史的name：', name)
          if (name === 'sendMsgClick' || name === '语音识别结果'){
            addHistoryText(allString)
          }

          console.log("数据流2下载完毕 str === DONE\n\n", allString);
          return Promise.resolve();
        }
        // str = str.split("data: ");
        // let newStreamDataSSE = str && str[str.length - 1];

        const newStreamDataSSE = str;

        if (newStreamDataSSE !== "[DONE]") {
          allString += newStreamDataSSE;
          // .replace(/\n/, "$^N^$")
          // .replace(/\r/, "$^R^$");
          if (step) {
            // const strList = newStreamDataSSE.split("\n");
            const strList = newStreamDataSSE.split(step);
            // 拿第一个,补上符号
            pString += strList[0] + step;
            if (pString) {
              console.error("!!!!!!!!!!!!! 3 _sendMsgAnswerShowAndPlayEvent");
              // 反馈给tts
              console.log('反馈给tts pString:' + pString)
              Vue.prototype?.$_sendMsgAnswerShowAndPlayEvent(
                pString,
                "pString",
                textModel
              );
            }
            // 有可能不止一个，有好几个个\n合在一起，所以取剩下的,length-1可能就是0
            const strListLength = strList.length
            if (strList && strListLength > 1) {
              const newList = strList.slice(1, strList.length);
              pString = newList.join(step) || "";
            } else {
              pString = "";
            }
          } else {
            pString += newStreamDataSSE;
          }
        }
      }
    };




    await readStream.call(this); // 使用call方法确保箭头函数中的this引用正确的Vue组件实例
    clearController();
  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      /* if(error === 'TypeError: Failed to fetch'){
        console.log('TypeError: Failed to fetch')
      } */
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败", noShowToast: true  });
      }

    }
  }
}

const extractJson = (jsonString) => {
  var regex = /{[^{}]+}/g
  var jsonObjects = jsonString.match(regex)
  if (!jsonObjects) {
    return {
      originStr: jsonString
    }
  }
  const obj = {
    originStr: jsonString
  }
  if (typeof jsonObjects !== 'undefined') {
    if (jsonObjects.length > 0) {
      obj.intent = jsonObjects[0]
    }
    obj.originStr = getTextAfterLastBrace(jsonString)
  }
  return obj
}

const getTextAfterLastBrace = (str) => {
  const lastBraceIndex = str.lastIndexOf('}')
  if (lastBraceIndex === -1) return ''
  return str.slice(lastBraceIndex + 1).trim()
}

/* export const askApiStream2 = async (text) => {
  console.warn(`🚀 ~ file: askApiStream.js:34 ~ askApiStream ~ text : ` + text + '***end');
  if (!text) {
    return Promise.reject({ msg: "缺少必备参数" });
  }

  const id = String(store?.state?.vuex_app_project_data?.id);
  if (id === "undefined") {
    return Promise.reject({ msg: "缺少项目ID" });
  }
  try {
    try {
      await setNewAbortController();
    } catch (error) {
      console.error(
        `🚀 ~ file: askApiStream.js:45 ~ askApiStream ~ error : `,
        error
      );
    }

    loading = true;
    axios.post(preUrl + "chat-stream",
      {
      history: [],
      project_id: id,
      project_name: store?.state?.vuex_app_project_data?.name,
      question: text,
      },
      {
      responseType: 'stream',
      headers: {
        "Content-Type": "application/json",
        Accept: "text/event-stream",
        Authorization: "Bearer " + store?.state?.vuex_app_token || "",
      },
    }).then(response =>{

      const stream = response.data
      // 处理流式数据
      stream.on('data', chunk => {
        // 处理每个数据块
      });

      stream.on('end', () => {
        // 数据流结束
      });

      stream.on('error', error => {
        // 处理错误
      });



    }).catch(error => {
      // 处理请求错误
      console.log('处理请求错误', error)
    })

  } catch (error) {
    clearController();
    console.error(
      `🚀 ~ file: askApiStream.js:207 ~ askApiStream ~ error :`,
      error
    );
    if (error?.toString()?.indexOf("The user aborted a request") > -1) {
      return Promise.reject({ msg: "用户中断生成", noShowToast: true });
    } else {
      if (error instanceof TypeError) {
        console.log('错误类型是 TypeError'); //{var i=new Uint8Array(t.length+r.value.length)
      } else {
        return Promise.reject({ msg: "回复获取失败" });
      }
    }
  }
}; */
